<template>
  <div v-if="poll" class="chat-poll pa-3" :style="{ background: bg, color: ink }">
    <div class="d-flex align-start">
      <div class="poll-question">{{ question }}</div>
      <div v-if="poll.closed" class="poll-closed ml-2">
        <v-icon size="11" color="#B91C1C">mdi-lock-outline</v-icon>
        <span>Хаагдсан</span>
      </div>
    </div>

    <div class="poll-subtitle" :style="{ color: inkSoft }">{{ subtitle }}</div>

    <div
      v-for="(option, index) in poll.options"
      :key="index"
      class="poll-option"
      :style="optionStyle(index)"
      @click="vote(index)"
    >
      <div
        v-if="showResults && percent(index) > 0"
        class="poll-fill"
        :style="{ width: percent(index) + '%', background: fade(0.12) }"
      />
      <div class="poll-row">
        <v-icon size="24" :color="picked(index) ? ink : inkFaint">
          {{ icon(index) }}
        </v-icon>
        <span class="poll-answer">{{ option || "—" }}</span>
        <template v-if="showResults">
          <span class="poll-percent">{{ percent(index) }}%</span>
          <span class="poll-count" :style="{ color: inkSoft }">
            ({{ count(index) }})
          </span>
        </template>
      </div>
    </div>

    <div class="poll-voters">
      {{ poll.voters ? poll.voters + " хүн санал өгсөн" : "Хэн ч санал өгөөгүй" }}
    </div>

    <div class="poll-actions">
      <a
        v-if="!poll.anonymous || nationalAdmin"
        class="poll-action"
        @click.stop="openVoters"
      >
        <v-icon size="18" :color="ink">mdi-information-outline</v-icon>
        <span>Хэн сонгосон</span>
      </a>
      <a v-if="mine" class="poll-action" @click.stop="openEdit">
        <v-icon size="18" :color="ink">mdi-pencil-outline</v-icon>
        <span>Засах</span>
      </a>
      <a v-if="mine" class="poll-action" @click.stop="toggleClosed">
        <v-icon size="18" :color="ink">
          {{ poll.closed ? "mdi-lock-open-variant-outline" : "mdi-lock-outline" }}
        </v-icon>
        <span>{{ poll.closed ? "Нээх" : "Хаах" }}</span>
      </a>
    </div>

    <v-dialog v-model="editOpen" max-width="400">
      <v-card>
        <v-card-title class="text-subtitle-1">Санал асуулга засах</v-card-title>
        <v-divider />
        <v-card-text class="pt-4">
          <v-textarea
            v-model="editQuestion"
            rows="2"
            auto-grow
            dense
            hide-details
            class="mb-3"
          />
          <div
            v-for="(option, index) in editOptions"
            :key="index"
            class="d-flex align-center mb-1"
          >
            <v-text-field
              v-model="option.text"
              dense
              hide-details
              :placeholder="index + 1 + '-р хариулт'"
            />
            <v-btn
              v-if="editOptions.length > 2"
              icon
              small
              @click="editOptions.splice(index, 1)"
            >
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-btn
            v-if="editOptions.length < 10"
            text
            small
            color="blue"
            @click="editOptions.push({ text: '' })"
          >
            <v-icon small left>mdi-plus</v-icon> Хариулт нэмэх
          </v-btn>

          <v-switch
            v-model="editAnonymous"
            dense
            hide-details
            class="mt-3"
            label="Нэрээ нууцлах"
          />

          <div v-if="presets.length" class="mt-4">
            <div class="poll-swatch-label">ӨНГӨ</div>
            <div class="poll-swatches">
              <div
                v-for="(preset, index) in presets"
                :key="index"
                class="poll-swatch"
                :style="swatchStyle(preset)"
                @click="editColors = preset"
              >
                <v-icon v-if="sameColors(preset, editColors)" size="24" :color="swatchInk(preset)">
                  mdi-check-bold
                </v-icon>
                <span v-else :style="{ color: swatchInk(preset) }">Аа</span>
              </div>
            </div>
          </div>

          <div
            v-if="optionsChanged && poll.voters"
            class="red--text text-caption mt-3"
          >
            Хариултыг өөрчилвөл өгсөн {{ poll.voters }} санал цуцлагдана.
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="editOpen = false">Болих</v-btn>
          <v-btn color="green" dark depressed @click="saveEdit">Хадгалах</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="votersOpen" max-width="380">
      <v-card>
        <v-card-title class="text-subtitle-2">{{ question }}</v-card-title>
        <v-divider />
        <v-card-text style="max-height: 60vh; overflow-y: auto" class="pa-0">
          <template v-for="(option, index) in poll.options">
            <div :key="'h' + index" class="grey lighten-4 px-4 py-2">
              <b style="font-size: 13px">{{ option }} — {{ count(index) }}</b>
            </div>
            <div
              v-for="(person, n) in votersOf(index)"
              :key="index + person.userId"
              class="px-4 py-2"
              style="font-size: 14px"
            >
              {{ n + 1 }}. {{ person.name }}
              <div v-if="person.school" class="grey--text" style="font-size: 13px">
                {{ person.school }}
              </div>
            </div>
          </template>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="votersOpen = false">Хаах</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  votePoll,
  watchMyVote,
  pollVotes,
  setPollClosed,
  editPoll,
  pollColorPresets,
  pollBackgroundOf,
  pollTextColorOf,
} from "./chat.js";

export default {
  name: "ChatPoll",
  props: {
    school: { type: Object, default: null },
    roomId: { type: String, required: true },
    message: { type: Object, required: true },
    me: { type: Object, required: true },
    mine: Boolean,
  },
  data() {
    return {
      presets: [],
      myVote: [],
      voters: [],
      votersOpen: false,
      editOpen: false,
      editQuestion: "",
      editOptions: [],
      editAnonymous: true,
      editColors: null,
      stop: null,
    };
  },
  computed: {
    poll() {
      return this.message.poll || null;
    },
    // Санал асуулга өнгөө өөртөө авч явна; өнгөгүй нь чатны бөмбөлгийн өнгө.
    bg() {
      return pollBackgroundOf(this.poll);
    },
    ink() {
      return pollTextColorOf(this.poll);
    },
    // Дотоод бүх зүйл текстийн өнгийг дагана, эс бөгөөс бараан дэвсгэр дээр
    // саарал холбоос, саарал радио үл үзэгдэнэ.
    inkSoft() {
      return this.fade(0.85);
    },
    inkFaint() {
      return this.fade(0.5);
    },
    // The question is also kept in the message text, so an older poll still
    // reads properly here.
    question() {
      return this.poll.question || this.message.content || "";
    },
    nationalAdmin() {
      const role = (this.$store.state.userData || {}).role;
      return role === "superadmin" || role === "superadmin2";
    },
    // Answers stay hidden until this person has picked one; national admins always see them.
    showResults() {
      return (
        this.myVote.length > 0 ||
        (this.poll && this.poll.closed) ||
        this.nationalAdmin
      );
    },
    optionsChanged() {
      const before = this.poll.options || [];
      const now = this.editedOptions;
      return (
        before.length !== now.length || before.some((text, i) => text !== now[i])
      );
    },
    editedOptions() {
      return this.editOptions
        .map((option) => option.text.trim())
        .filter((text) => text !== "");
    },
    subtitle() {
      if (!this.poll) return "";
      if (this.poll.closed) return "Дууссан санал асуулга";
      if (this.poll.multiple) return "Олон хариулттай санал асуулга";
      return this.poll.anonymous
        ? "Нэргүй санал асуулга"
        : "Нээлттэй санал асуулга";
    },
  },
  async created() {
    this.presets = await pollColorPresets();

    this.stop = watchMyVote(
      this.school,
      this.roomId,
      this.message.id,
      this.me.id,
      (options) => {
        this.myVote = options;
      },
    );
  },
  beforeDestroy() {
    if (this.stop) this.stop();
  },
  methods: {
    /// The configured ink at a lower strength — Vuetify's colour props take a
    /// css value, so rgba() is what both the icon and the fill accept.
    fade(alpha) {
      const hex = String(this.ink).replace("#", "");
      if (hex.length !== 6) return this.ink;
      const r = parseInt(hex.slice(0, 2), 16);
      const g = parseInt(hex.slice(2, 4), 16);
      const b = parseInt(hex.slice(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
    optionStyle(index) {
      return {
        background: this.fade(this.picked(index) ? 0.1 : 0.05),
        cursor: this.poll.closed ? "default" : "pointer",
      };
    },
    swatchStyle(preset) {
      const bg = pollBackgroundOf(preset);
      return {
        background: bg,
        border: this.paleColor(bg) ? "1px solid #E5E7EB" : "none",
      };
    },
    swatchInk(preset) {
      return pollTextColorOf(preset);
    },
    paleColor(hex) {
      const digits = String(hex).replace("#", "");
      if (digits.length !== 6) return true;
      const r = parseInt(digits.slice(0, 2), 16) / 255;
      const g = parseInt(digits.slice(2, 4), 16) / 255;
      const b = parseInt(digits.slice(4, 6), 16) / 255;
      return 0.2126 * r + 0.7152 * g + 0.0722 * b > 0.85;
    },
    sameColors(a, b) {
      if (!a || !b) return false;
      return (a.bg || "") === (b.bg || "") && (a.text || "") === (b.text || "");
    },
    picked(index) {
      return this.myVote.includes(index);
    },
    count(index) {
      return (this.poll.counts || [])[index] || 0;
    },
    percent(index) {
      if (!this.poll.voters) return 0;
      return Math.round((this.count(index) / this.poll.voters) * 100);
    },
    icon(index) {
      const picked = this.myVote.includes(index);
      if (this.poll.multiple) {
        return picked ? "mdi-checkbox-marked" : "mdi-checkbox-blank-outline";
      }
      return picked ? "mdi-radiobox-marked" : "mdi-radiobox-blank";
    },
    async vote(index) {
      if (this.poll.closed) return;

      let next = [...this.myVote];
      if (this.poll.multiple) {
        next = next.includes(index)
          ? next.filter((i) => i !== index)
          : [...next, index];
      } else {
        // Tapping the answer you already picked takes the vote back.
        next = next.includes(index) ? [] : [index];
      }
      await votePoll(this.school, this.roomId, this.message.id, this.me, next);
    },
    async openVoters() {
      this.voters = await pollVotes(this.school, this.roomId, this.message.id);
      this.votersOpen = true;
    },
    votersOf(index) {
      return this.voters.filter((v) => (v.options || []).includes(index));
    },
    async toggleClosed() {
      const closed = !this.poll.closed;
      await setPollClosed(this.school, this.roomId, this.message.id, closed);
      this.$swal.fire({
        toast: true,
        position: "top-end",
        icon: closed ? "info" : "success",
        title: closed ? "Санал асуулга хаагдлаа" : "Дахин нээгдлээ",
        showConfirmButton: false,
        timer: 1600,
      });
    },
    openEdit() {
      this.editQuestion = this.question;
      this.editOptions = (this.poll.options || []).map((text) => ({ text }));
      this.editAnonymous = this.poll.anonymous !== false;
      this.editColors =
        this.presets.find((preset) =>
          this.sameColors(preset, {
            bg: this.poll.bg || "",
            text: this.poll.text || "",
          }),
        ) || null;
      this.editOpen = true;
    },
    async saveEdit() {
      const options = this.editedOptions;
      if (!this.editQuestion.trim() || options.length < 2) return;

      await editPoll(
        this.school,
        this.roomId,
        this.message.id,
        this.editQuestion.trim(),
        options,
        this.editAnonymous,
        this.editColors,
      );
      this.editOpen = false;
    },
  },
};
</script>

<style scoped>
.chat-poll {
  width: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 15px;
}

.poll-question {
  flex: 1;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.35;
}

.poll-closed {
  display: flex;
  align-items: center;
  gap: 3px;
  flex-shrink: 0;
  padding: 3px 8px;
  border-radius: 20px;
  background: #fee2e2;
  color: #b91c1c;
  font-size: 10.5px;
}

.poll-subtitle {
  margin-top: 2px;
  margin-bottom: 10px;
  font-size: 12.5px;
}

/* Хариулт бүр бүтэн мөр — жижиг дугуй биш, хуруунд багтах талбай. */
.poll-option {
  position: relative;
  overflow: hidden;
  min-height: 48px;
  margin-bottom: 8px;
  border-radius: 12px;
}

.poll-fill {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  border-radius: 12px;
}

.poll-row {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 48px;
  padding: 10px 12px;
}

.poll-answer {
  flex: 1;
  font-size: 15px;
  line-height: 1.3;
}

.poll-percent {
  font-size: 14px;
}

.poll-count {
  font-size: 12.5px;
}

.poll-voters {
  margin-top: 2px;
  font-size: 13px;
}

.poll-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
}

.poll-action {
  display: flex;
  align-items: center;
  gap: 5px;
  min-height: 36px;
  padding: 6px 8px;
  border-radius: 8px;
  font-size: 13px;
  color: inherit;
  white-space: nowrap;
  cursor: pointer;
}

.poll-action:hover {
  background: rgba(0, 0, 0, 0.05);
}

.poll-swatch-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.8px;
  color: #757575;
  margin-bottom: 8px;
}

.poll-swatches {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 8px;
}

.poll-swatch {
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1;
  border-radius: 50%;
  font-size: 17px;
  cursor: pointer;
}
</style>
